import { useState, useEffect } from "react";
import React from "react";
import axios from "axios";
import secureLogo from "../../assets/images/security-model.png";
import otpTitleBg from "../../assets/card/send-tokens-title-bg.svg";
import OtpIcon from "../assets/Currency.svg"; // Adjust to your actual SVG path
import { refreshTokenV2 } from "../../services/api";
import { useDispatch, useSelector } from "react-redux";
import { initialToken } from "../Pages/RoundToJoin/tocken.slice";
import { baseURL } from "../services/axiosConfig";



const OtpPopup = ({
  onClose,
  onVerify,
  onResend,
  tokens = "",
  receiverEmail = "",
  senderEmail = "",
  displayName = "",
  transferId = "", // New prop for transfer_id
  formData = {}, // New prop for original form data (for resend)
  availableTokens,
  setAvailableTokens
}) => {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(30); // 30 seconds timer
  const [resendActive, setResendActive] = useState(false);
  const [error, setError] = useState(""); // State for error messages

  const otpGTM = useSelector((state) => state.otpGTMSlice.otpGTM);
  const toUserInfo = useSelector((state) => state.otpGTMSlice.toUserInfo);

  const allFilled = otp.every(
    (digit) => digit.length === 1 && /\d/.test(digit)
  );

  useEffect(() => {
    let timer;
    if (!resendActive && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setResendActive(true);
    }
    return () => clearInterval(timer);
  }, [timeLeft, resendActive]);

  const handleOtpChange = (index, value) => {
    if (value.length > 1 && /^\d{2,}$/.test(value)) {
      const values = value.split("").slice(0, 4);
      setOtp((prev) => prev.map((d, i) => values[i] || ""));
    } else if (/^\d?$/.test(value)) {
      setOtp((prev) => prev.map((d, i) => (i === index ? value : d)));
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && otp[idx] === "") {
      if (idx > 0) e.target.form[idx - 1].focus();
    }
    if (e.key === "ArrowRight" && idx < otp.length - 1) {
      e.target.form[idx + 1].focus();
    }
    if (e.key === "ArrowLeft" && idx > 0) {
      e.target.form[idx - 1].focus();
    }
  };

  async function fetchProfile() {
    try {
      const token = localStorage.getItem("access_token");
      const profileRes = await axios.get(
        `${baseURL}/accounts/user/me`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      dispatch(initialToken(profileRes?.data?.available_tokens + profileRes?.data?.won_tokens));
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
    }
  }

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!allFilled) {
      setError("Please enter a valid 4-digit OTP.");
      return;
    }
    if (!transferId) {
      setError("No transfer ID provided. Please try again.");
      return;
    }

    setError("");
    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("No access token found. Please log in again.");
        return;
      }

      let authToken;
      try {
        authToken = JSON.parse(token);
      } catch (parseError) {
        console.error("Error parsing access token:", parseError);
        setError("Invalid access token format. Please log in again.");
        return;
      }

      const payload = {
        transfer_id: transferId,
        otp: otp.join(""),
      };

      const response = await axios.post(
        `${baseURL}/accounts/send-token/confirm/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        const userInfo = localStorage.getItem("userInfo");
        const userId = userInfo ? JSON.parse(userInfo).userId : null;

        window.dataLayer.push({
          'event': 'token_transfer',
          'fromUserId': userId,
          'toName': toUserInfo.name,
          'toUserId': toUserInfo.toUserId,
          'tokenAmount': Number(otpGTM.tokens) * Number(process.env.REACT_APP_PRICE_PER_TOKEN)
        });
        setAvailableTokens(availableTokens - tokens)
        fetchProfile()
        onVerify(response.data);

      }
    } catch (err) {
      console.error("Error verifying OTP:", {
        message: err.message,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        headers: err.response?.headers,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          data: err.config?.data,
        },
      });
      if (err?.response?.status === 401) {
        await refreshTokenV2(dispatch);
        // Optionally retry the request after refresh
        // handleVerify(e); // Uncomment if auto-retry is desired
        setError("Session expired. Please log in again.");
      } else if (err?.response?.status === 400) {
        setError(err.response?.data?.error || "Invalid OTP. Please try again.");
      } else if (err?.response?.status === 404) {
        setError("Invalid transfer ID. Please start the transfer again.");
      } else {
        setError(
          err.response?.data?.error || "Failed to verify OTP. Please try again."
        );
      }
    }
  };

  const handleResendClick = async () => {
    if (!resendActive) return;
    setTimeLeft(30);
    setResendActive(false);
    setOtp(["", "", "", ""]);
    setError("");

    try {
      const token = localStorage.getItem("access_token");
      if (!token) {
        setError("No access token found. Please log in again.");
        return;
      }

      let authToken;
      try {
        authToken = JSON.parse(token);
      } catch (parseError) {
        console.error("Error parsing access token:", parseError);
        setError("Invalid access token format. Please log in again.");
        return;
      }

      const payload = {
        token_count: Number(formData.tokens),
        display_name: formData.displayName?.trim(),
        email: formData.email?.trim(),
        name: formData.name?.trim() || "",
      };

      console.log("Resend Request URL:", `${baseURL}/accounts/send-token/request/`);
      console.log("Resend Request Payload:", payload);
      console.log("Authorization Header:", `Bearer ${authToken}`);

      const response = await axios.post(
        `${baseURL}/accounts/send-token/request/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {
        onResend(response.data);
      }
    } catch (err) {
      console.error("Error resending OTP:", {
        message: err.message,
        status: err.response?.status,
        statusText: err.response?.statusText,
        data: err.response?.data,
        headers: err.response?.headers,
        config: {
          url: err.config?.url,
          method: err.config?.method,
          data: err.config?.data,
        },
      });
      if (err?.response?.status === 401) {
        await refreshTokenV2(dispatch);
        setError("Session expired. Please log in again.");
      } else if (err?.response?.status === 404) {
        setError("User not found. Please check display name and email.");
      } else if (err?.response?.status === 500) {
        setError(
          err.response?.data?.error ||
          "Server error occurred. Please try again."
        );
      } else {
        setError(
          err.response?.data?.error || "Failed to resend OTP. Please try again."
        );
      }
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/90 flex justify-center items-center p-3 sm:p-4"
      onClick={onClose}
    >
      <div className="flex items-center justify-center w-full h-full">
        <div
          className="bg-[#F6FAFF] rounded-lg shadow-lg max-w-md w-full max-h-[80vh] flex flex-col overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Gradient header / Title with close */}
          <div className="relative flex justify-center items-center">
            <img
              src={otpTitleBg}
              alt="OTP Verification"
              className="w-[180px] sm:w-[220px] h-auto mx-auto"
            />
            <button
              className="absolute top-2 right-2 md:right-6 text-[#787878] text-lg sm:text-2xl w-[18px] h-[18px] sm:w-[20px] sm:h-[20px] opacity-100 border-0 flex items-center justify-center"
              onClick={onClose}
            >
              ×
            </button>
          </div>

          {/* MODAL CONTENT */}
          <form
            className="p-4 sm:p-6 w-full flex flex-col items-center gap-0"
            onSubmit={handleVerify}
          >
            <div className="flex flex-col items-center mb-2 w-full">
              {/* OTP Icon */}
              <img
                src={OtpIcon}
                alt="OTP Icon"
                className="mb-3 w-7 h-7 sm:w-8 sm:h-8"
              />

              {tokens && (
                <div className="font-inter font-bold mb-3 sm:mb-4 text-[22px] sm:text-[28px] text-[#0081F8]">
                  {tokens} Tokens
                </div>
              )}

              {/* Sending To with Display Name and Receiver Email */}
              {receiverEmail && (
                <div className="w-full font-inter text-center text-[#00000080] font-normal text-sm sm:text-base mb-4 sm:mb-6 text-gray-500">
                  Sending to{" "}
                  {displayName && (
                    <span className="text-sm sm:text-base mb-0.5">
                      {displayName}
                    </span>
                  )}
                  <div className="font-inter text-[#00000080] text-sm sm:text-base break-all">
                    <span className="block text-sm sm:text-base font-normal">
                      {receiverEmail}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* White background section for OTP message + inputs */}
            <div className="bg-white rounded-xl p-3 sm:p-4 shadow-sm flex flex-col items-center w-full mb-4 sm:mb-6">
              {senderEmail && (
                <div className="font-inter text-base sm:text-lg text-gray-800 text-center mb-3 sm:mb-4">
                  Enter the code that we sent to <br />
                  <span className="font-archivo text-[#0081F8] break-all text-sm sm:text-base">
                    {senderEmail}
                  </span>
                </div>
              )}

              {/* OTP fields */}
              <div className="flex items-center gap-0 px-2 mb-2 sm:mb-3">
                {otp.map((digit, idx) => (
                  <React.Fragment key={idx}>
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      autoFocus={idx === 0}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^[0-9]$/.test(val)) {
                          handleOtpChange(idx, val);

                          // Move to next input automatically
                          if (idx < otp.length - 1) {
                            const nextInput = document.getElementById(
                              `otp-input-${idx + 1}`
                            );
                            if (nextInput) nextInput.focus();
                          }
                        } else if (val === "") {
                          handleOtpChange(idx, "");
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Backspace" && !otp[idx] && idx > 0) {
                          const prevInput = document.getElementById(
                            `otp-input-${idx - 1}`
                          );
                          if (prevInput) prevInput.focus();
                        }
                      }}
                      id={`otp-input-${idx}`}
                      className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl border border-gray-300 bg-white text-xl sm:text-2xl text-center font-bold font-archivo focus:border-[#007FFF] outline-none"
                    />
                    {idx < otp.length - 1 && (
                      <span className="mx-1 sm:mx-2 text-gray-400 text-2xl sm:text-3xl font-light">
                        -
                      </span>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Resend Timer */}
              <div className="text-xs sm:text-sm text-gray-500">
                {resendActive ? (
                  <button
                    type="button"
                    onClick={handleResendClick}
                    className="text-[#007FFF] underline hover:text-[#0056b3] text-xs sm:text-sm"
                  >
                    Resend Code
                  </button>
                ) : (
                  <span>
                    Resend code in{" "}
                    <span className="font-medium">{timeLeft}s</span>
                  </span>
                )}
              </div>
            </div>

            {/* Error display */}
            {error && (
              <div className="text-center text-red-500 text-sm mb-4">
                {error}
              </div>
            )}

            {/* Verify & Send Button */}
            <div className="flex justify-center mb-3 sm:mb-4 w-full">
              <button
                type="submit"
                disabled={!allFilled}
                className={`w-[60%] sm:w-[50%] px-4 py-2 sm:px-6 sm:py-3 rounded-lg text-sm sm:text-base font-inter transition-colors duration-200 ${allFilled
                  ? "bg-[#00C05B] text-white hover:bg-[#00a24b] cursor-pointer"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  }`}
              >
                Verify & Send
              </button>
            </div>

            <div className="text-center text-[10px] sm:text-xs text-gray-500 pb-3 sm:pb-4">
              <span className="inline-flex items-center gap-1">
                Your security is more important to us{" "}
                <img
                  src={secureLogo}
                  alt="logo"
                  className="inline w-[55px] h-[24px] sm:w-[62.57px] sm:h-[27.23px]"
                />
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OtpPopup;